module.exports = __webpack_public_path__ + "img/draw.5d5f8457.png";